import React, { useState, useEffect } from "react";
import { Row, Col, Card } from "react-bootstrap";
const AboutPage = () => {
  const [menu, setMenu] = useState([]);
  const [partnels, setPartnels] = useState([]);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 768);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  useEffect(() => {
    getMenu();
    getPartner();
  }, []);
  const getMenu = () => {
    fetch("/json/aboutMenu.json")
      .then((response) => response.json())
      .then((data) => setMenu(data))
      .catch((error) => console.error("menu:", error));
  };

  const getPartner = () => {
    fetch("/json/partner.json")
      .then((response) => response.json())
      .then((data) => setPartnels(data))
      .catch((error) => console.error("partnels:", error));
  };

  return (
    <div>
      <div className="page-title">
        <h1>About RUISI-GLOBAL</h1>
      </div>

      <Row>
        <Col xs={12} md={3}>
          <Card
            style={{
              maxHeight: isMobile
                ? "calc(100vh - 40px)"
                : "calc(100vh - 100px)",
              overflowY: "auto",
              padding: isMobile ? "1rem" : "1.5rem",
              position: isMobile ? "static" : "sticky",
              top: isMobile ? "auto" : "100px",
              left: isMobile ? "auto" : 0,
              zIndex: 10,
            }}
          >
            <Card.Header className="tab-header">
              <h3
                style={{
                  color: "#2c3e50",
                  paddingBottom: "10px",
                  margin: 0,
                  fontSize: isMobile ? "1.2rem" : "1.3rem",
                }}
              >
                Overview
              </h3>
            </Card.Header>
            <Card.Body style={{ padding: 0 }}>
              <ul className="p-0">
                {menu.map(({ id, title, link }) => (
                  <li key={id}>
                    <a
                      href={link}
                      className={`btn d-flex justify-content-between align-items-center btn-secondary`}
                      style={{
                        display: "block",
                        textAlign: "left",
                        padding: "8px 15px",
                        borderRadius: "8px",
                        transition: "all 0.3s ease",
                        width: "100%",
                      }}
                    >
                      <span
                        style={{
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          flexGrow: 1,
                          marginRight: "8px",
                        }}
                      >
                        {title}
                      </span>
                    </a>
                  </li>
                ))}
              </ul>
            </Card.Body>
          </Card>
        </Col>
        <Col xs={12} md={9}>
          <main style={{ flex: 1 }}>
            <div className="card">
              <div className="page_content">
                <div className="mb-30">
                  <h2 className="mb-20 h2-title">About RUISI-GLOBAL</h2>
                  <p style={{ textAlign: "justify" }}>
                    RUISI Global was established in 2025 as an open access
                    academic publishing platform registered in Hong Kong,
                    dedicated to integrating global academic resources through
                    digital innovation. With a vision of “Connecting Research,
                    Inspiring Innovation,” Ruisiglobal focuses on publishing
                    high-quality journals across the fields of science,
                    technology, and medicine. By leveraging advanced internet
                    technologies and data-driven publishing models, Ruisiglobal
                    aims to accelerate the dissemination of scientific knowledge
                    and promote international academic collaboration. The
                    company actively cooperates with global publishers,
                    universities, and research societies to advance open access
                    and build a transparent, efficient, and inclusive academic
                    ecosystem.
                  </p>
                </div>
              </div>
            </div>
            <div className="card">
              <div className="page__content">
                <div className="mb-30">
                  <h2 className="mb-20 h2-title">Corporate Partners</h2>
                  <Row>
                    {partnels.map((_, index) => (
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="d-flex justify-center p-3"
                        key={index}
                      >
                        <div
                          className="d-flex"
                          style={{ flexDirection: "column" }}
                        >
                          {_.link ? (
                            <a
                              href={_.link}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <img
                                style={{
                                  objectFit: "cover",
                                  height: "50px",
                                  cursor: "pointer",
                                }}
                                src={_.url}
                                alt="img"
                              />
                            </a>
                          ) : (
                            <img
                              style={{
                                objectFit: "cover",
                                height: "50px",
                              }}
                              src={_.url}
                              alt="img"
                            />
                          )}
                        </div>
                      </Col>
                    ))}
                  </Row>
                </div>
              </div>
            </div>
          </main>
        </Col>
      </Row>
    </div>
  );
};

export default AboutPage;
